/* eslint-disable multiline-ternary */
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [
    'sm',
    {
      title: 'md',
      isDefault: true
    },
    'lg'
  ],
  modifiers: [],
  state: []
}

function BrandGroup(props) {
  const { sm, md, lg, brands } = props
  const displayedBrands = brands?.filter((brand) => brand?.isVisible === true)
  const hidedBrands = brands?.filter((brand) => brand?.isVisible === false)

  return (
    <div className={resolveProps(props, config, 'BrandGroup')}>
      {displayedBrands?.map((brand, index) => (
        <figure key={`displayed_${index}`} className="mdn-BrandGroup-image">
          <img
            className="mdn-BrandGroup-image"
            src={brand.src}
            alt={brand.alt}
          />
          <figcaption className="mdn-BrandGroup-image-caption mdn-Tooltip mdn-Tooltip--top">
            <p className="mdn-Text mdn-Text--caption mdn-Text--inverse">
              {brand.alt}
            </p>
          </figcaption>
        </figure>
      ))}
      {hidedBrands.length >= 1 ? (
        <div className="mdn-BrandGroup-etc">
          <span className="mdn-BrandGroup-etc-value">
            +{hidedBrands.length}
          </span>
          <div className="mdn-BrandGroup-etc-items mdn-Tooltip mdn-Tooltip--left mdn-Tooltip--content">
            <div className="mdn-TopicDetails mdn-TopicDetails--brand">
              {hidedBrands.map((brand, index) => (
                <div key={`etc_${index}`} className="mdn-TopicDetails-group">
                  <div className="mdn-Topic mdn-Topic--horizontal mdn-Topic--sm">
                    <div className="mdn-Topic-symbol">
                      <img src={brand.src} alt={brand.alt} />
                    </div>
                    <p className="mdn-Topic-description">{brand.alt}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  )
}

export default BrandGroup

BrandGroup.propTypes = {
  sm: PropTypes.bool,
  md: PropTypes.bool,
  lg: PropTypes.bool,
  brands: PropTypes.arrayOf(
     PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
      isVisible: PropTypes.bool
    })
  )
}
